import React, {useEffect, useRef, useState} from 'react';
import MessageBubble from './MessageBubble';
import MessageInput from './MessageInput';
import TemplateModal from './TemplateModal';
import { formatChatDateLabel } from '../../utils/dateUtils';

const ChatWindow =({
    conversation,
    messages,
    onSendMessage,
    onSendFile,
    onAttendConversation,
    onCloseConversation,
    onShowContactInfo,
    plantillas = [],
    onSendTemplate
}) => {
    const messagesEndRef = useRef(null);
    const containerRef = useRef(null);
    const firstLoadRef = useRef(true);
    const shouldAutoScrollRef = useRef(true);
    const prevMessagesLengthRef = useRef(0);
    const [showNewIndicator, setShowNewIndicator] = useState(false);
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    

    const scrollToBottom = (behavior = "smooth") => {
        messagesEndRef.current?.scrollIntoView({ behavior });
        setShowNewIndicator(false);
    };


    //Detectar el scroll manual del usuario
     useEffect(() => {
      const container = containerRef.current;
      if (!container) return;

      const handleScroll = () => {
        const threshold = 80;

        const isUserAtBottom =
          container.scrollHeight - container.scrollTop - container.clientHeight < threshold;

        shouldAutoScrollRef.current = isUserAtBottom;

        if (isUserAtBottom) {
          setShowNewIndicator(false);
        }
      };

      container.addEventListener("scroll", handleScroll);
          return () => container.removeEventListener("scroll", handleScroll);
        }, []);

        useEffect(() => {
        if (!messages) return;

        const isFirstLoad = firstLoadRef.current;
        const previousLength = prevMessagesLengthRef.current;
        const currentLength = messages.length;

        const isNewMessage = currentLength > previousLength;

        prevMessagesLengthRef.current = currentLength;

        if (isFirstLoad) {
          firstLoadRef.current = false;
          scrollToBottom("auto");
          return;
        }

        if (!isNewMessage) return;

        if (shouldAutoScrollRef.current) {
          scrollToBottom("smooth");
        } else {
          setShowNewIndicator(true);
        }
      }, [messages]);


    useEffect(() => {
        firstLoadRef.current = true;
        prevMessagesLengthRef.current = 0;
        
      setTimeout(() => {
        scrollToBottom("auto");
      }, 100);
        
    }, [conversation]);

    if (!conversation) {
        return (
            <div className="chat-window-empty">
                <p>Selecciona una conversación para comenzar</p>
            </div>
        );
    }

    return (
        <div className="chat-window">
      <div className="chat-header">
        <div className="contact-info" onClick={onShowContactInfo} style={{ cursor: 'pointer' }}>
          <h4 title="Click para ver información del contacto">{conversation.nombreContacto || conversation.numeroWhatsapp}</h4>
          <span className={`status ${conversation.atendidaPor ? 'attended' : 'unattended'}`}>
            {conversation.atendidaPor ? `Atendida por ${conversation.atendidaPor}` : 'Sin atender'}
          </span>
        </div>
        
        <div className="chat-actions">
          {!conversation.atendidaPor && (
            <button onClick={onAttendConversation} className="attend-btn">
              Atender
            </button>
          )}
          <button onClick={onCloseConversation} className="close-btn">
            Cerrar
          </button>
        </div>
      </div>

      <div className="messages-container" ref={containerRef}>
        {/* {Array.isArray(messages) && messages.map(message => (
          <MessageBubble key={message.id} message={message} />
        ))} */}
        {Array.isArray(messages) && 
          messages.map((message, index) => {
            const currentDate = new Date(message.fechaMensaje);
            let showDateLabel = false;

            if (index === 0) {
              showDateLabel = true;
            } else {
              const prevDate = new Date(messages[index - 1].fechaMensaje);
               showDateLabel = 
                currentDate.toDateString() !== prevDate.toDateString();
            }
            return (
              <React.Fragment key={message.id}>
                  {showDateLabel && (
                    <div className='date-label'>{formatChatDateLabel(message.fechaMensaje)}</div>
                  )}
                  <MessageBubble message={message} />
              </React.Fragment>
            )
          })
        }
        <div ref={messagesEndRef} />
         {showNewIndicator && (
                    <div
                        className="new-messages-indicator"
                        onClick={() => scrollToBottom()}
                        style={{
                            position: "sticky",
                            bottom: "10px",
                            textAlign: "center",
                            cursor: "pointer",
                            color: "#007bff",
                            fontSize: "13px"
                        }}
                    >
                        Nuevos mensajes ↓
                    </div>
                )}
      </div>

      <MessageInput
        onSendMessage={onSendMessage}
        onSendFile={onSendFile}
        onOpenTemplateModal={onSendTemplate ? () => setShowTemplateModal(true) : undefined}
      />

      {showTemplateModal && (
        <TemplateModal
          plantillas={plantillas}
          onClose={() => setShowTemplateModal(false)}
          onSend={onSendTemplate}
        />
      )}
    </div>
    );
};

export default ChatWindow;